import TilbyService from "shared/services/TilbyService"

export const createPayment = (accountId, params) => () => {
  return TilbyService.createPayment(accountId, params)
    .then(payment => {
      return Promise.resolve(payment);
    });
}

export const initWebhook = (accountId) => () => {
  return TilbyService.initWebhook(accountId)
    .then(data => {
      // DO NOTHING FOR NOW, since we are listening to websocket
      return Promise.resolve(data);
    });
}
